import type { StandaloneIconProps } from '@/components/element/Icon';
import DefaultSwiper, { StandaloneSwiper } from '@/components/element/Slider/Swiper';
import { standaloneComponent } from 'modules/dynamic-components';

const Icon = standaloneComponent<StandaloneIconProps>('ElementIcon');

const arrow = <Icon name="sliderArrow" options={{ size: 'none', className: 'h-10 w-6.5' }} />;

export const MabraStandaloneSwiper: typeof StandaloneSwiper = (props) => {
  return <StandaloneSwiper {...{ arrow }} {...props} />;
};

export const standalone = MabraStandaloneSwiper;

export default DefaultSwiper;
